import { render, staticRenderFns } from "./SystemComponentsHierarchiesComponent.vue?vue&type=template&id=586f5320&"
import script from "./SystemComponentsHierarchiesComponent.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchiesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports